import store from '../store'
import SecondLayout from '@/views/layout/SecondLayout'
import { i18n } from '@/i18n'
import { UserLevel } from '@/utils/constants'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export function beforeFun(to, from, next) {
  const level = store.state.user.userInfo.level
  const roleType = store.state.user.userInfo.roleType
  const signed = roleType === ROLE_TYPE_ENUM.COMPANY.code ? !!store.state.user.company.signStatus : undefined
  if (to.name === 'homePage') { // 首页不做处理
    next()
  } else if (ROLE_TYPE_ENUM.AI_PUBLISH.code === roleType && !to.path.includes('/ai_publish')) { // AI发行用户不能进入数字音乐平台的页面
    next({ name: 'notExist' })
  } else if (level === UserLevel.INIT.code && !['registerEdit', 'notRegistry'].includes(to.name)) { // 没注册用户只能进入引导页面
    next({ name: 'notRegistry' })
  } else if (level > UserLevel.INIT.code && level < UserLevel.PASS.code && to.name !== 'registerEdit') { // 没有经过审核的用户跳转到信息审核详情页
    next({ name: 'registerEdit', query: { roleType, signed } })
  } else if (level >= UserLevel.PASS.code && ['registerEdit', 'notRegistry'].includes(to.name)) { // 已经审核通过的用户不能进入引导&审核页面
    next({ name: 'homePage' })
  } else {
    next()
  }
}

function normalPermCheck() {
  const { isAdmin, isEditor, isBussiness, isCompany, isFinance, isCompanyOnline, isInfringement, isClaim } = store.getters
  return isAdmin || isCompany || isEditor || isBussiness || isFinance || isCompanyOnline || isInfringement || isClaim
}

function appealPermCheck() {
  const { isAdmin, isOther, isBussiness, isLegal, isFinance } = store.getters
  return isAdmin || isLegal || isBussiness || isOther || isFinance
}

function applyPermCheck() {
  const { isAdmin, isEditor, isBussiness, isCompany, isLegal, isFinance, isCompanyOnline, isInfringement, isClaim } = store.getters
  return isAdmin || isCompany || isEditor || isBussiness || isLegal || isFinance || isCompanyOnline || isInfringement || isClaim
}

function dataPermCheck() {
  return store.getters.showDataManage
}

// 内容权益申诉
function contentAppealPermCheck() {
  const { isAdmin, isEditor, isFinance, isInfringement, isClaim } = store.getters
  return isAdmin || isEditor || isFinance || isInfringement || isClaim
}

// 外部申诉
function outsideAppealPermCheck() {
  const { isAdmin, isEditor, isBussiness, isCompany, isFinance, isCompanyOnline, isLegal, isThirdParty, isInfringement, isClaim } = store.getters
  return isAdmin || isEditor || isBussiness || isCompany || isFinance || isCompanyOnline || isLegal || isThirdParty || isInfringement || isClaim
}

// 版权入库任务
function cpTaskPermCheck() {
  const { isAdmin, isBussiness, isCpTrackOnline } = store.getters
  return isAdmin || isBussiness || isCpTrackOnline
}

// 合同管理
function contractPermCheck() {
  const { isAdmin, isCompany, isBussiness, isLegal, isFinance } = store.getters
  return isAdmin || isCompany || isBussiness || isLegal || isFinance
}

export default function(Layout) {
  return [
    {
      path: '/person',
      component: Layout,
      name: 'person',
      meta: { title: i18n.t('nav.profile'), icon: 'user' },
      redirect: '/person/index',
      beforeEnter: beforeFun,
      isShow() {
        return true
      },
      children: [
        {
          path: 'home',
          name: 'personHome',
          isShow() {
            return !store.getters.isAIPublish
          },
          component: () => import(/* webpackChunkName: "personHome" */ '@/views/person/personHome'),
          meta: { title: i18n.t('person.personHome'), icon: '' },
        },
        {
          path: 'index',
          name: 'personIndex',
          isShow() {
            return !store.getters.isAIPublish
          },
          component: () => import(/* webpackChunkName: "personIndex" */ '@/views/person/index'),
          meta: { title: i18n.t('nav.basic'), icon: '' },

        },
        {
          path: 'notice',
          name: 'personNotice',
          isShow() {
            return !store.getters.isAIPublish
          },
          meta: { title: i18n.t('nav.message'), icon: '' },
          component: () => import(/* webpackChunkName: "personNotice" */ '@/views/notice/index'),
        },
        {
          path: 'edit',
          name: 'personEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "personEdit" */ '@/views/person/edit'),
          meta: { title: i18n.t('person.edit'), icon: 'list' },
        },
        {
          path: 'register_edit',
          name: 'registerEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "registerEdit" */ '@/views/person/registerEdit/index'),
          meta: { title: i18n.t('person.edit'), icon: 'list', hideSidebar: true, hideBreadcrumb: true },
        },
      ],

    },
    {
      path: '/content',
      name: 'content',
      component: Layout,
      meta: { title: i18n.t('nav.contentManagement'), icon: 'album' },
      redirect: '/person/album/list',
      isShow() {
        return normalPermCheck()
      },
      beforeEnter: beforeFun,
      children: [
        {
          path: '/person/track/list',
          name: 'trackList',
          component: () => import(/* webpackChunkName: "trackList" */ '@/views/track/list'),
          meta: { title: i18n.t('nav.trackManagement'), icon: '', authCheck: normalPermCheck },
          isShow() {
            return normalPermCheck()
          }
        },
        {
          path: '/person/track/edit',
          name: 'trackEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "trackEdit" */ '@/views/track/edit'),
          meta: { title: '歌曲修改', icon: 'edit', authCheck: normalPermCheck }
        },
        {
          path: '/person/album/list',
          name: 'albumList',
          component: () => import(/* webpackChunkName: "albumList" */ '@/views/album/list'),
          meta: { title: i18n.t('nav.albumManagement'), icon: '', authCheck: normalPermCheck },
          isShow() {
            return normalPermCheck()
          }
        },
        {
          path: '/person/album/edit',
          name: 'albumEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "albumEdit" */ '@/views/album/edit'),
          meta: { title: '专辑录入', icon: 'edit', authCheck: normalPermCheck }
        },
        {
          path: '/person/mv/list',
          name: 'mvList',
          component: () => import(/* webpackChunkName: "mvList" */ '@/views/mv/list'),
          meta: { title: i18n.t('nav.mvManagement'), icon: '', authCheck: normalPermCheck },
          isShow() {
            return normalPermCheck()
          }
        },
        {
          path: '/person/mv/edit',
          name: 'mvEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "mvEdit" */ '@/views/mv/edit'),
          meta: { title: '视频录入', icon: 'edit', authCheck: normalPermCheck }
        },
        {
          path: '/person/singer/list',
          name: 'singerList',
          meta: { title: i18n.t('nav.singerManagement'), icon: '', authCheck: normalPermCheck },
          isShow() {
            return normalPermCheck()
          },
          component: () => import(/* webpackChunkName: "singerList" */ '@/views/singer/list')
        },
        {
          path: '/person/contract/list',
          name: 'contractList',
          meta: { title: i18n.t('nav.contractManagement'), icon: '', authCheck: normalPermCheck },
          isShow() {
            return contractPermCheck()
          },
          component: () => import(/* webpackChunkName: "contractList" */ '@/views/contract/list')
        },
        {
          path: '/person/contract/detail',
          name: 'contractDetail',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "contractDetail" */ '@/views/contract/detail'),
          meta: { title: '合同详情', icon: '', authCheck: normalPermCheck }
        },
        {
          path: '/applyModify',
          name: 'applyModify',
          meta: { title: i18n.t('nav.modifyRecord'), icon: '' },
          // component: Layout,
          redirect: '/person/applyModify/song',
          component: SecondLayout,
          isShow() {
            return applyPermCheck()
          },
          children: [
            {
              path: '/person/applyModify/song',
              name: 'applyModifySong',
              meta: { title: i18n.t('nav.modifyTrack'), icon: '', authCheck: applyPermCheck },
              isShow() {
                return applyPermCheck()
              },
              component: () => import(/* webpackChunkName: "applyModifySongList" */ '@/views/applyModify/song')
            },
            {
              path: '/person/applyModify/album',
              name: 'applyModifyAlbum',
              meta: { title: i18n.t('nav.modifyAlbum'), icon: '', authCheck: applyPermCheck },
              isShow() {
                return applyPermCheck()
              },
              component: () => import(/* webpackChunkName: "applyModifyAlbumList" */ '@/views/applyModify/album')
            },
            {
              path: '/person/applyModify/mv',
              name: 'applyModifyMv',
              meta: { title: i18n.t('nav.modifyMv'), icon: '', authCheck: applyPermCheck },
              isShow() {
                return applyPermCheck()
              },
              component: () => import(/* webpackChunkName: "applyModifyMvList" */ '@/views/applyModify/mv')
            },
            {
              path: '/person/check/cp',
              name: 'checkCpList',
              component: () => import(/* webpackChunkName: "checkCpList" */ '@/views/check/cp/list/index'),
              meta: { title: '版权审核', icon: '', authCheck: applyPermCheck },
              isShow() {
                return appealPermCheck()
              }
            },

            {
              path: '/person/check/detail/:id',
              name: 'checkCpDetail',
              component: () => import(/* webpackChunkName: "checkCpDetail" */ '@/views/check/cp/detail/index'),
              meta: { title: '版权审核详情', icon: '', authCheck: applyPermCheck },
              isShow() {
                return false
              }
            },
          ]
        },
      ]
    },
    {
      path: '/data',
      name: 'data',
      component: Layout,
      meta: { title: i18n.t('nav.data'), icon: 'data' },
      redirect: '/person/data/works',
      beforeEnter: beforeFun,
      isShow() {
        return dataPermCheck()
      },
      children: [
        {
          path: '/person/data/works',
          name: 'dataWorks',
          component: () => import(/* webpackChunkName: "dataWorks" */ '@/views/data/works/index.vue'),
          meta: { title: i18n.t('nav.product'), icon: '', authCheck: dataPermCheck },
          isShow() {
            return dataPermCheck()
          }
        },
        {
          path: '/person/data/fans',
          name: 'dataFans',
          component: () => import(/* webpackChunkName: "dataFans" */ '@/views/data/fans'),
          meta: { title: i18n.t('nav.user'), icon: '', authCheck: dataPermCheck },
          isShow() {
            return dataPermCheck()
          }
        },
      ]
    },
    {
      path: '/income',
      name: 'income',
      component: Layout,
      meta: { title: i18n.t('nav.income'), icon: 'income' },
      redirect: '/person/income/settlement',
      beforeEnter: beforeFun,
      isShow() {
        if (store.getters.isCompanyOnline) return false
        return normalPermCheck()
      },
      children: [
        {
          path: '/person/income/settlement',
          name: 'settlement',
          component: () => import(/* webpackChunkName: "settlement" */ '@/views/income/settlement'),
          meta: { title: i18n.t('nav.settle'), icon: '', authCheck: normalPermCheck },
          isShow() {
            if (store.getters.isCompanyOnline) return false
            return normalPermCheck()
          }
        }
      ]
    },
    // 内容权益申诉
    {
      path: '/appeal',
      name: 'appeal',
      component: Layout,
      meta: { title: i18n.t('nav.appeal'), icon: 'appeal' },
      redirect: '/person/appeal/outside/tort/list',
      beforeEnter: beforeFun,
      isShow() {
        return contentAppealPermCheck() || outsideAppealPermCheck()
      },
      children: [
        {
          path: '/person/appeal/list',
          name: 'appealList',
          component: () => import(/* webpackChunkName: "appealList" */ '@/views/complaint/inner/index.vue'),
          meta: { title: i18n.t('nav.toAppeal'), icon: '', authCheck: contentAppealPermCheck },
          isShow() {
            return contentAppealPermCheck()
          }
        },
        {
          path: '/person/appeal/edit',
          name: 'appealEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "appealEdit" */ '@/views/complaint/inner/edit'),
          meta: { title: i18n.t('nav.appealEdit'), icon: '', authCheck: contentAppealPermCheck }
        },
        {
          path: '/person/appeal/outside/cp_tort/list',
          name: 'outsideCpTortList',
          component: () => import(/* webpackChunkName: "outsideCpTortList" */ '@/views/complaint/outside/cpTort/list/index.vue'),
          meta: { title: '版权申诉', icon: '', authCheck: outsideAppealPermCheck },
          isShow() {
            return outsideAppealPermCheck()
          }
        },
        {
          path: '/person/appeal/outside/cp_tort/edit',
          name: 'outsideCpTortEdit',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "outsideCpTortEdit" */ '@/views/complaint/outside/cpTort/edit/index.vue'),
          meta: { title: '新建申诉', icon: '', authCheck: outsideAppealPermCheck }
        },
        {
          path: '/person/appeal/outside/cp_tort/detail',
          name: 'outsideCpTortDetail',
          isShow() {
            return false
          },
          component: () => import(/* webpackChunkName: "outsideCpTortDetail" */ '@/views/complaint/outside/cpTort/detail/index.vue'),
          meta: { title: '申诉详情', icon: '', authCheck: outsideAppealPermCheck }
        },
      ]
    },
    {
      path: '/cp_task',
      name: 'cpTask',
      component: Layout,
      meta: { title: i18n.t('cpTask.cpTaskTitle'), icon: 'judge' },
      redirect: '/person/cpTask/list',
      beforeEnter: beforeFun,
      isShow() {
        return cpTaskPermCheck()
      },
      children: [
        {
          path: '/person/cp_task/list',
          name: 'cpTaskList',
          component: () => import(/* webpackChunkName: "cpTaskList" */ '@/views/cpTask/list'),
          meta: { title: i18n.t('cpTask.cpTaskListTitle'), icon: '', authCheck: cpTaskPermCheck },
          isShow() {
            return cpTaskPermCheck()
          }
        },
        {
          path: '/person/cp_task/detail',
          name: 'cpTaskDetail',
          component: () => import(/* webpackChunkName: "cpTaskDetail" */ '@/views/cpTask/detail/index'),
          meta: { title: i18n.t('cpTask.cpTaskDetailTitle'), icon: '', authCheck: cpTaskPermCheck },
          isShow() {
            return false
          }
        },
      ]
    },
  ]
}
